<template>
  <div class="page-wrapper">
    <div class="app-card-lg policy-card">
      <h1 class="policy-title">用户协议</h1>
      <div class="policy-content">
        <p>更新时间：2026年4月10日</p>
        <p>生效时间：2026年4月10日</p>
        <p>
          欢迎您使用温岭 EATing 创意融合轻食相关网站、小程序及配套服务（以下统称“本服务”）。
          本《用户协议》由您与实际运营方温岭 EATing 创意融合轻食（以下称“运营方”）共同缔结。
          温岭迅驰软件开发工作室（以下称“技术支持方”）仅提供系统开发、维护与技术支持服务，不参与餐饮经营、商品销售、配送履约及资金结算。
          请您在注册、登录、下单或使用本服务前，认真阅读并充分理解本协议全部条款。
        </p>

        <h2>第一章 协议主体与适用范围</h2>
        <ul>
          <li>协议主体：您与运营方。</li>
          <li>技术支持方角色：仅提供技术能力，不作为交易相对方，不承担商家经营责任、食品质量责任及交易结算责任。</li>
          <li>适用范围：网站端、小程序端及关联功能，包括但不限于注册登录、订餐、随心订、兑换券、订单延期、支付、地址管理、售后与客服。</li>
          <li>签约方式：您点击“同意”或实际使用本服务，即视为已阅读并同意本协议。</li>
        </ul>

        <h2>第二章 账号注册与管理</h2>
        <ul>
          <li>您应使用真实、合法、有效的信息注册并维护账号资料，确保手机号、收货信息等准确可用。</li>
          <li>您应妥善保管账号、验证码、登录凭证，不得出借、出租、转让账号。</li>
          <li>如发现账号异常或疑似被盗用，请立即联系运营方客服处理。</li>
          <li>您应对账号下全部操作及法律后果承担责任，法律另有规定的除外。</li>
        </ul>

        <h2>第三章 服务内容与业务规则</h2>
        <h3>3.1 订餐与普通订单</h3>
        <ul>
          <li>您可浏览商品信息、选择规格与数量、提交订单并完成支付。</li>
          <li>订单提交后，请以页面展示的订单状态、配送方式、配送时段与实际通知为准。</li>
        </ul>
        <h3>3.2 随心订服务</h3>
        <ul>
          <li>随心订为周期性配送服务，具体以页面展示的周期、餐次、份数、价格和规则为准。</li>
          <li>随心订订单可按页面规则执行延期；延期后以系统最新显示的配送计划为准。</li>
          <li>若您选择暂停、恢复或取消随心订，以页面提示及执行结果为准。</li>
        </ul>
        <h3>3.3 兑换券与优惠权益</h3>
        <ul>
          <li>兑换券/优惠券的领取、使用门槛、有效期、适用范围以券面规则及下单页说明为准。</li>
          <li>您不得通过刷券、倒券、作弊等方式牟利，违规时运营方有权限制使用并追究责任。</li>
        </ul>
        <h3>3.4 收货地址与配送信息</h3>
        <ul>
          <li>您应准确填写收货人姓名、电话、地址及必要备注；因信息错误造成的损失由您承担。</li>
          <li>配送时效受天气、交通、订单峰值等因素影响，运营方将尽力履约。</li>
        </ul>

        <h2>第四章 支付、退款与结算说明</h2>
        <ul>
          <li>您可通过平台支持的支付方式完成付款，支付由持牌支付机构处理。</li>
          <li>技术支持方不直接收取用户餐费，不参与运营方与用户之间资金结算。</li>
          <li>退款规则依据订单状态、商品属性及页面规则执行；如涉及线下核验，以运营方通知为准。</li>
        </ul>

        <h2>第五章 用户行为规范</h2>
        <ul>
          <li>不得利用本服务实施违法行为，包括但不限于欺诈下单、虚假投诉、恶意退款、攻击系统、抓取数据等。</li>
          <li>不得发布或传播违反法律法规、公序良俗或侵犯他人权益的内容。</li>
          <li>不得干扰平台正常运行或损害运营方、技术支持方及其他用户合法权益。</li>
        </ul>

        <h2>第六章 免责与责任限制</h2>
        <ul>
          <li>运营方对食品生产经营、配送履约、售后处理承担相应法律责任。</li>
          <li>技术支持方仅对系统可用性与技术支持承担相应义务，不对运营决策、商品质量、配送结果及资金纠纷承担责任。</li>
          <li>因不可抗力、第三方服务故障、通信故障、系统维护等导致的服务中断，双方按法律规定各自承担责任。</li>
        </ul>

        <h2>第七章 个人信息与隐私保护</h2>
        <p>
          运营方与技术支持方将按照法律法规及《隐私政策》处理您的个人信息。您理解并同意为实现下单、配送、支付、客服等必要目的进行信息处理。
          详细规则请查阅《隐私政策》。
        </p>

        <h2>第八章 协议变更、终止与通知</h2>
        <ul>
          <li>运营方有权根据业务发展、法律法规变化更新本协议，并通过页面公告或弹窗方式提示。</li>
          <li>如您不同意更新内容，请停止使用本服务；继续使用视为接受更新后的协议。</li>
          <li>如您严重违反本协议，运营方可采取限制功能、暂停服务、终止服务等措施。</li>
        </ul>

        <h2>第九章 法律适用与争议解决</h2>
        <ul>
          <li>本协议适用中华人民共和国法律（不含冲突法规则）。</li>
          <li>因本协议产生争议，双方应先协商解决；协商不成的，提交运营方所在地有管辖权的人民法院处理。</li>
        </ul>

        <h2>第十章 联系方式</h2>
        <ul>
          <li>运营方（实际经营）：温岭 EATing 创意融合轻食</li>
          <li>运营方联系方式：13958677072</li>
          <li>技术支持方：温岭迅驰软件开发工作室</li>
          <li>技术支持方联系方式：wenlingxunchi@163.com</li>
        </ul>
      </div>
      <div class="policy-footer">
        <el-button class="btn-primary" @click="$router.push('/login')">返回登录页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserAgreement'
}
</script>

<style scoped>
.page-wrapper {
  padding: 24px;
  min-height: 100vh;
  background: var(--page-bg);
  display: flex;
  justify-content: center;
}

.policy-card {
  max-width: 960px;
}

.policy-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-title);
  text-align: center;
  margin-bottom: 16px;
}

.policy-content {
  font-size: 14px;
  line-height: 1.8;
  color: var(--text-body);
}

.policy-content h2 {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-title);
  margin-top: 16px;
  margin-bottom: 8px;
}

.policy-content h3 {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-subtitle);
  margin-top: 12px;
  margin-bottom: 4px;
}

.policy-footer {
  margin-top: 24px;
  text-align: center;
}
</style>

